import { render, staticRenderFns } from "./OnboardingCommentIcon.vue?vue&type=template&id=76ffacf7"
import script from "./OnboardingCommentIcon.vue?vue&type=script&lang=js"
export * from "./OnboardingCommentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports